import React from 'react';
import { getOrderDateAndTime } from 'shared/helpers/orders';
import { OrderRow, OrderRowCellLabel, OrderRowTextButton, OrderRowButton } from 'components/order-row/order-row';
import { getUniqueOrderImages } from 'components/order-row/get-unique-order-images';
import { OrderThumbnails } from 'components/order-row/order-thumbnails';
import { ConsumerOrder } from 'components/embedded-account/account.types';

type OrderListItemProps = {
  canViewStatus: boolean;
  order: ConsumerOrder;
  onViewOrder: () => void;
  onReorder?: () => void;
  reorderLoading?: boolean;
};

const OrderListItem = ({
  canViewStatus,
  order,
  onViewOrder,
  onReorder,
  reorderLoading,
}: OrderListItemProps): JSX.Element => {
  const { dispensary, deliveryInfo, totalCost, orders: orderItems } = order;
  const isDelivery = deliveryInfo?.deliveryOption;
  const title = dispensary?.name ?? '';
  const orderType = isDelivery ? 'Delivery' : 'Pickup';
  const parsed = parseFloat(totalCost ?? '0');
  const totalCostString = `$${(Number.isNaN(parsed) ? 0 : parsed).toFixed(2)}`;

  const typeCol = (
    <>
      <OrderRowCellLabel>type</OrderRowCellLabel>
      <span>{orderType}</span>
    </>
  );

  const totalCol = (
    <>
      <OrderRowCellLabel>total</OrderRowCellLabel>
      <span>{totalCostString}</span>
    </>
  );

  const actions = (
    <>
      {onReorder && !canViewStatus && (
        <OrderRowButton variant='secondary' onClick={onReorder} disabled={reorderLoading}>
          {reorderLoading ? 'Reordering...' : 'Reorder'}
        </OrderRowButton>
      )}
      {canViewStatus ? (
        <OrderRowButton onClick={onViewOrder}>View Order</OrderRowButton>
      ) : (
        <OrderRowTextButton onClick={onViewOrder}>View Receipt</OrderRowTextButton>
      )}
    </>
  );

  return (
    <OrderRow
      title={title}
      date={getOrderDateAndTime(order)}
      desktopCol2={typeCol}
      desktopCol3={totalCol}
      mobileCol2={orderType}
      mobileCol3={totalCostString}
      actions={actions}
      thumbnails={<OrderThumbnails images={getUniqueOrderImages(orderItems)} />}
    />
  );
};

export default OrderListItem;
